function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M377.008,10174.5H357.992a.492.492,0,0,1-.492-.492V10158.8a.492.492,0,0,1,.144-.348l3.8-3.8a.49.49,0,0,1,.348-.145h15.213a.492.492,0,0,1,.492.492v19.016A.492.492,0,0,1,377.008,10174.5Zm-18.525-.983h18.033v-18.033H362l-3.515,3.516Z",
  transform: "translate(-357.5 -10154.502)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(4.918 0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M382.172,10162.043h-9.18a.492.492,0,0,1-.492-.492v-6.557a.492.492,0,1,1,.984,0v6.065h8.2v-6.065a.492.492,0,1,1,.984,0v6.557A.492.492,0,0,1,382.172,10162.043Z",
  transform: "translate(-372.5 -10154.502)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(7.541 2.295)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M380.992,10163.8a.492.492,0,0,1-.492-.492v-1.311a.492.492,0,1,1,.984,0v1.311A.492.492,0,0,1,380.992,10163.8Z",
  transform: "translate(-380.5 -10161.502)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(3.934 11.803)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M381.139,10198.7a.492.492,0,0,1-.492-.492v-6.721H370.484v6.721a.492.492,0,1,1-.984,0v-7.213a.492.492,0,0,1,.492-.492h11.148a.492.492,0,0,1,.492.492v7.213A.492.492,0,0,1,381.139,10198.7Z",
  transform: "translate(-369.5 -10190.502)"
})));

var SvgSave = function SvgSave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20.001,
      viewBox: "0 0 20 20.001",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgSave, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Save.a13dfd1d.svg";
export { ForwardRef as ReactComponent };